/**
 * Gets the API base URL.
 * References site declaration from /declarations/assets.d.ts to match live environments
 */
export function getApiBaseUrl(): string {
  return site.baseUrl.replace("{{protocol}}", window.location.protocol).replace("{{hostname}}", window.location.hostname);
}
